<template>
  <v-row>
    <v-col cols="12">
      <h2>Billing Overview</h2>

    </v-col>

    <v-col cols="12">
      <v-card>
        <v-card-title>

              <router-link
                custom v-slot="{ navigate }"
                :to="`/credit-billing/${id}/bills`"
              >
                <v-btn
                  small
                  class="ma-2"
                  color="green" @click="navigate" role="link">
                  View all Bills
                </v-btn>
              </router-link
              >
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="developmentData.billing"
          :search="search"
          item-key="name"
          class="elevation-1"
        >
          <template #item.type="{ value }">
            <v-chip
              :color="getBillType(value, 'color')"
              dark
              small
            >
              {{ getBillType(value, 'name') }}
            </v-chip>

          </template>

        </v-data-table>
      </v-card>
    </v-col>


  </v-row>
</template>

<script>
import {get} from "vuex-pathify";
import {creditBilling} from "@/mixins/credit-billing";

export default {
  name: "CreditBillingSingleBillOverview",
  props: {
    id: String
  },
  computed: {
    developmentData: get('creditBilling/development'),
  },
  mixins: [creditBilling],
  data: () => ({
    search: '',
    headers: [
      {
        text: 'Name',
        align: 'start',
        value: 'name',
      },
      {text: 'Type', value: 'type'},
      {text: 'Last Billing', value: 'last_billing'},
      {text: 'Next Billing', value: 'next_billing'},
    ],
  }),
  methods: {
    formatterDate(value, withoutTime) {
      if (!value) {
        return "";
      }
      return this.formatDate(value, true, !withoutTime);
    }
  }
}
</script>

<style scoped>

</style>
